export const pl = {
    translation: {
        common: {
            trial: "Wersja próbna",
            expired: "Wygasła",
            renewal: "Odnowienie",
            quantity: "Ilość",
            error: "Błąd",
            all: "Wszystkie",
            loading: "Ładowanie...",
            thank_you: "Dziękujemy",
            confirm: "Potwierdź",
            cancel: "Anuluj",
            save: "Zapisz",
            add: "Dodaj",
            edit: "Edytuj",
            delete: "Usuń",
            warning: "Ostrzeżenie",
            delete_confirm_text: "Tej operacji nie można cofnąć. Czy na pewno chcesz usunąć?",
            click_to_select: "Wybierz...",
            unit: "Jednostka",
            detail: "Szczegóły",
            done: "Gotowe",
            search: "Szukaj",
            processing: "Przetwarzanie...",
            success: "Sukces",
            total: "Razem",
            none: "Brak"
        },
        roles: {
            admin: "Admin",
            barista: "Barista",
            waiter: "Kelner",
            kitchen: "Kuchnia"
        },
        auth: {
            user_not_found: "Nie znaleziono użytkownika!",
            welcome: "Witaj ponownie",
            subtitle: "Zaloguj się, aby zarządzać swoją kawiarnią",
            google_login: "Zaloguj się przez Google",
            apple_login: "Zaloguj się przez Apple",
            secure_login: "Bezpieczne logowanie",
            terms_text: "Logując się, akceptujesz nasze Warunki korzystania z usługi oraz Politykę prywatności."
        },
        sidebar: {
            dashboard: "Panel główny",
            tables: "Stoliki",
            staff: "Personel",
            loyalty: "CRM i Lojalność",
            qr_menu: "Menu QR",
            menu_product: "Menu i produkty",
            stock_recipe: "Magazyn i receptury",
            reports: "Raporty",
            settings: "Ustawienia",
            admin_panel: "Panel administratora",
            not_logged_in: "Niezalogowany",
            click_to_select: "Wybierz profil",
            switch_profile: "Zmień profil",
            logout: "Wyloguj się"
        },
        dashboard: {
            overview: "Przegląd panelu",
            today: "Dzisiaj",
            system_active: "System aktywny",
            offline: "Tryb offline",
            payment_reminder: "Przypomnienie o płatności",
            payment_missing_list: "Płatność za {{names}} nie została jeszcze dokonana.",
            add_expense: "Dodaj wydatek",
            daily_revenue: "Dzienny przychód",
            open_tables: "Otwarte stoliki",
            pending_tables: "Oczekujące zamówienia",
            waiting_approval: "Czeka na zatwierdzenie",
            active_staff: "Aktywny personel",
            hourly_revenue: "Przychód godzinowy",
            hourly_profit: "Zysk godzinowy",
            work_hours: "Godziny pracy",
            hours_24: "24 godziny",
            revenue: "Przychód",
            profit: "Zysk",
            best_sellers: "Bestsellery",
            support_modal: { other: "Inne" },
            weekly_performance: "Wyniki tygodniowe",
            weekly_revenue: "Przychód tygodniowy",
            increase: "Wzrost",
            decrease: "Spadek",
            busiest_day: "Najbardziej zajęty dzień",
            view_report: "Zobacz raport",
            critical_stock_warning: "Stan krytyczny magazynu",
            quick_actions: "Szybkie akcje",
            x_report: "Raport X",
            sync: "Synchronizuj",
            backup: "Kopia zapasowa",
            support: "Wsparcie",
            help_support: "Pomoc i wsparcie",
            help_desc: "Jak możemy Ci pomóc?",
            report_issue: "Zgłoś problem",
            version: "Wersja",
            topic: "Temat",
            technical: "Problem techniczny",
            suggestion: "Sugestia",
            other: "Inne",
            description: "Opis",
            desc_placeholder: "Proszę opisać problem...",
            send_report: "Wyślij zgłoszenie"
        },
        tables: {
            status: {
                occupied: "Zajęty",
                paid: "Zapłacone",
                reserved: "Zarezerwowane",
                empty: "Wolny"
            },
            alerts: {
                reservation_time: "Czas rezerwacji:",
                draft_paid: "Zapłacone zamówienie robocze",
                draft_unpaid: "Zamówienie robocze"
            },
            title: "Plan stolików",
            tabs: {
                plan: "Plan",
                history: "Historia"
            },
            filter: {
                all: "Wszystkie"
            },
            actions: {
                finish_edit: "Zakończ edycję",
                edit: "Edytuj stoliki",
                add_table: "Dodaj stolik",
                quick_pay: "Szybka płatność",
                reserve: "Rezerwuj",
                clear: "Wyczyść"
            },
            card: {
                capacity: "Osób",
                just_now: "Przed chwilą",
                total: "Suma",
                has_request: "Nowe zgłoszenie",
                no_order: "Brak zamówienia"
            },
            history: {
                search_placeholder: "Szukaj numeru paragonu lub stolika...",
                multi_pay: "Płatność zbiorcza"
            },
            sections: {
                manage: "Zarządzaj sekcjami",
                add_placeholder: "Nazwa nowej sekcji",
                no_sections: "Brak zdefiniowanych sekcji."
            },
            modal: {
                edit_title: "Edytuj stolik",
                add_title: "Dodaj stolik",
                name: "Nazwa stolika",
                name_placeholder: "np. Stolik 5",
                section: "Sekcja",
                capacity: "Pojemność",
                delete: "Usuń stolik",
                unpaid_warning_title: "Nieuregulowany rachunek!",
                clear_confirm_title: "Wyczyścić stolik?",
                unpaid_warning_text: "<b>{{name}}</b> ma nieopłacony rachunek. Wyczyszczenie go zresetuje zamówienie.",
                clear_confirm_text: "Czy na pewno chcesz wyczyścić <b>{{name}}</b>?",
                delete_confirm_text: "Czy na pewno chcesz usunąć <b>{{name}}</b>?"
            },
            qr_review: {
                title: "Przychodzące zamówienie QR",
                subtitle: "Nowa prośba od {{name}}",
                current_state: "Aktualny stan stolika",
                table_empty: "Stolik jest obecnie pusty.",
                current_total: "Aktualna suma",
                incoming_request: "Przychodzące zamówienie",
                extra_total: "Dodatkowa suma",
                reject: "Odrzuć",
                overwrite: "Nadpisz",
                overwrite_desc: "Wyczyść aktualne i ustaw nowe",
                merge: "Połącz",
                merge_desc: "Dodaj do istniejącego"
            }
        },
        orders: {
            status: {
                completed: "Zakończone"
            },
            list: {
                ticket_no: "Nr paragonu",
                date: "Data/Czas",
                table: "Stolik/Klient",
                method: "Metoda",
                amount: "Kwota",
                status: "Status"
            },
            modal: {
                match_error: "Suma płatności ({{pay}}₺) nie zgadza się z sumą zamówienia ({{total}}₺).",
                title: "Szczegóły transakcji",
                content_title: "Zawartość zamówienia",
                total_title: "Suma całkowita",
                payment_details: "Szczegóły płatności",
                entered_total: "Wprowadzona suma",
                difference: "Różnica"
            },
            correction: {
                note_placeholder: "np. Błąd wprowadzania danych przez personel"
            },
            void_flow: {
                button_update: "Aktualizuj status / Anuluj",
                button_void: "Anuluj / Zwrot",
                title_select: "Wybierz typ anulowania",
                type_cancel: "Błąd / Zwrot",
                type_cancel_desc: "Przywraca stan magazynowy",
                type_wastage: "Strata / Rozlane",
                type_wastage_desc: "Zdejmuje ze stanu (bez zwrotu)",
                confirm_cancel_title: "Oznacz jako Błąd/Zwrot",
                confirm_wastage_title: "Oznacz jako Stratę",
                confirm_cancel_text: "To anuluje sprzedaż i przywróci towar na magazyn. Czy na pewno?",
                confirm_wastage_text: "To anuluje sprzedaż, ale towar zostanie uznany za ZUŻYTY/STRACONY. Czy na pewno?",
                confirm: "POTWIERDŹ"
            }
        },
        pos: {
            title_quick: "Szybkie zamówienie",
            title_no_table: "Bez stolika",
            title_table: "{{name}}",
            search_placeholder: "Szukaj produktu...",
            grid: {
                sold_out: "WYPRZEDANE"
            },
            ticket: {
                title: "Aktualny rachunek",
                order_no: "NR ZAMÓWIENIA",
                new: "NOWE",
                empty: "Koszyk jest pusty.",
                status: {
                    wastage: "STRATA",
                    comp: "GRATIS",
                    cancelled: "ANULOWANE",
                    paid: "ZAPŁACONE"
                },
                discount_badge: "RABAT"
            },
            actions: {
                discount: "RABAT",
                comp: "GRATIS",
                void: "STRATA",
                cancel: "ANULUJ",
                pay: "PŁAĆ",
                assign_table: "STOLIK",
                save: "ZAPISZ",
                waiting_payment: "CZEKA NA PŁATNOŚĆ",
                close_ticket: "ZAMKNIJ RACHUNEK"
            },
            totals: {
                subtotal_net: "Suma netto",
                tax_vat: "Podatek (VAT)",
                grand_total: "Suma brutto",
                tax_exclusive_hint: "(+Podatek)"
            },
            alerts: {
                table_not_found: "Nie znaleziono stolika.",
                perm_comp: "Nie masz uprawnień do wydawania produktów gratis.",
                perm_void: "Nie masz uprawnień do anulowania pozycji.",
                select_item_error: "Proszę wybrać produkt.",
                paid_item_error: "Opłacone pozycje nie mogą być modyfikowane.",
                split_quantity: "Ile z {{count}} pozycji przenieść?",
                invalid_amount: "Nieprawidłowa kwota.",
                perm_discount: "Nie masz uprawnień do udzielania rabatów.",
                select_discount_item: "Wybierz produkt do rabatowania.",
                paid_discount_error: "Nie można rabatować opłaconych pozycji.",
                add_items_first: "Proszę najpierw dodać produkty do koszyka.",
                unauthorized: "Brak dostępu"
            },
            modifier_modal: {
                no_modifiers: "Brak dostępnych modyfikatorów.",
                multiple: "wiele",
                add_to_cart: "Dodaj do koszyka"
            },
            discount_modal: {
                title: "Zastosuj rabat",
                percent: "Procentowy",
                amount: "Kwotowy",
                comp_100: "GRATIS (100%)",
                old_total: "Poprzednia suma",
                new_total: "Nowa suma",
                apply: "Zastosuj rabat"
            }
        },
        payment: {
            alerts: {
                enter_valid: "Proszę wprowadzić prawidłową kwotę.",
                balance_not_zero: "Pozostałe saldo musi wynosić 0, aby zamknąć rachunek."
            },
            header_order: "Zamówienie",
            header_open: "Otwarty rachunek",
            ticket_details: "Szczegóły rachunku",
            select_all: "Zaznacz wszystko",
            items_count: "{{count}} produktów",
            empty_list: "Brak produktów",
            remaining_badge: "Pozostało: {{amount}}",
            recent_transactions: "OSTATNIE TRANSAKCJE",
            totals: {
                total: "Suma",
                paid: "Zapłacono",
                remaining: "Pozostało"
            },
            amount_to_collect: "Kwota do pobrania",
            give_change: "Reszta",
            return_to_customer: "Zwróć klientowi",
            methods: {
                cash: "Gotówka",
                card: "Karta płatnicza",
                qr: "QR / Mobilne",
                other: "Karta lunchowa"
            },
            numpad: {
                all: "Wszystko"
            },
            actions: {
                cancel: "Anuluj",
                close_ticket: "Zamknij rachunek",
                waiting_payment: "Czeka na płatność"
            }
        },
        menu: {
            title: "Zarządzanie menu",
            subtitle: "Zarządzaj produktami, cenami i zapasami",
            add_new: "Dodaj produkt",
            edit_title: "Edytuj produkt",
            add_title: "Dodaj produkt",
            manage_categories: "Zarządzaj kategoriami",
            alerts: {
                no_permission: "Nie masz uprawnień do zarządzania menu.",
                delete_confirm: "Czy na pewno chcesz usunąć ten produkt?"
            },
            form: {
                image_select: "Wybierz zdjęcie",
                image_change: "Zmień zdjęcie",
                image_recommendation: "Zalecany format kwadratowy",
                image_max_size: "Maks. 2MB",
                name: "Nazwa produktu",
                name_placeholder: "np. Latte",
                category: "Kategoria",
                price: "Cena",
                stock_tracking: "Śledzenie zapasów",
                stock_hint: "Wpisz 0, aby wyłączyć",
                description: "Opis",
                description_placeholder: "Składniki, szczegóły...",
                customizable: "Konfigurowalny (modyfikatory)"
            },
            categories: {
                title: "Zarządzanie kategoriami",
                add: "Dodaj kategorię",
                name: "Nazwa kategorii",
                edit: "Edytuj kategorię",
                delete_confirm: "Usunąć tę kategorię?"
            }
        },
        categories: {
            all: "Wszystkie",
            hot_coffees: "Kawy na gorąco",
            cold_coffees: "Kawy na zimno",
            desserts: "Desery",
            snacks: "Przekąski",
            barista_special: "Specjały"
        },
        stock: {
            title: "Zarządzanie zapasami",
            subtitle: "Magazyn, receptury i modyfikatory",
            tabs: {
                inventory: "Magazyn",
                recipes: "Receptury",
                modifiers: "Modyfikatory"
            },
            inventory: {
                total_value: "Całkowita wartość",
                sku_count: "Liczba SKU",
                alerts: "Alerty magazynowe",
                search_placeholder: "Szukaj w magazynie...",
                add_stock: "Dodaj pozycję",
                status_critical: "Krytyczny",
                status_warning: "Niski",
                status_sufficient: "OK",
                table: {
                    name: "Nazwa",
                    supplier: "Dostawca",
                    amount: "Ilość",
                    status: "Status",
                    unit_cost: "Koszt jedn.",
                    actions: "Akcje"
                },
                modal: {
                    edit_title: "Edytuj magazyn",
                    add_title: "Dodaj do magazynu",
                    general_info: "Informacje ogólne",
                    management: "Zarządzanie",
                    name: "Nazwa pozycji",
                    name_placeholder: "np. Mleko",
                    supplier: "Dostawca",
                    supplier_placeholder: "np. Lokalna mleczarnia",
                    unit: "Jednostka",
                    alarm_thresholds: "Progi alarmowe",
                    warning_limit: "Limit ostrzegawczy",
                    critical_limit: "Limit krytyczny",
                    stock_status: "Status zapasów",
                    finish_editing: "Zakończ edycję",
                    manual_correction: "Ręczna korekta",
                    current_amount: "Aktualna ilość",
                    unit_cost: "Koszt jedn.",
                    new_purchase: "Nowy zakup / Dostawa",
                    add_amount: "Dodaj ilość",
                    purchase_price: "Cena zakupu",
                    total: "Suma",
                    unit_price: "Cena jedn.",
                    success_feedback: "Zaktualizowano!",
                    calculate_add: "Oblicz i dodaj",
                    avg_cost_note: "* Oblicza średnią ważoną kosztów."
                }
            },
            wastage: {
                title: "Zgłoś stratę",
                subtitle: "Zgłaszanie straty dla {{name}}",
                amount: "Ilość",
                reason: "Powód",
                reason_placeholder: "np. Rozlane, Zepsute",
                report: "Zgłoś stratę"
            },
            recipes: {
                search_product: "Szukaj produktu...",
                gross_margin: "Marża brutto",
                sale_price: "Cena sprzedaży",
                cost_price: "Koszt własny",
                ingredients: "Składniki",
                no_recipe: "Brak zdefiniowanej receptury.",
                add_ingredient: "Dodaj składnik",
                stock_item: "Pozycja z magazynu",
                amount: "Ilość",
                unit: "Jednostka"
            },
            modifiers: {
                title: "Grupy modyfikatorów",
                new_group: "Nowa grupa",
                group_name: "Nazwa grupy",
                selection_type: "Typ wyboru",
                single: "Pojedynczy (Radio)",
                multiple: "Wielokrotny (Checkbox)",
                options: "Opcje",
                option_name: "Nazwa opcji",
                option_placeholder: "np. Mleko owsiane",
                extra_price: "Dodatkowa cena",
                deduct_stock: "Zdejmij z magazynu (opcjonalnie)",
                add_option: "Dodaj opcję",
                group_helper_text: "Zarządzaj opcjami dla tej grupy poniżej.",
                no_link: "Brak powiązania",
                stock_optional_label: "Magazyn (opcjonalnie)",
                edit_group_title: "Edytuj grupę",
                allow_multiple_label: "Zezwalaj na wielokrotny wybór",
                delete_group_confirm: "Czy na pewno chcesz usunąć tę grupę?"
            }
        },
        reports: {
            title: "Przegląd finansowy",
            filters: { today: "Dzisiaj", week: "Tydzień", month: "Miesiąc", all: "Wszystko" },
            kpi: {
                revenue: "Przychód całkowity",
                net_revenue: "Przychód netto",
                tax_collected: "Pobrany podatek",
                income: "Wpływy",
                expense: "Wydatki ogółem",
                expense_opr: "Operacyjne",
                expense_stock: "Koszt towaru (COGS)",
                expense_wastage: "Straty",
                profit: "Zysk netto",
                profit_opr: "Zysk operacyjny",
                cash_in_hand: "Przepływy pieniężne",
                gross_profit: "Zysk brutto",
                tickets: "Liczba rachunków",
                sales_count: "Liczba sprzedaży",
                expense_analysis: "Analiza wydatków",
                profit_analysis: "Analiza zysku netto",
                available_in_standard: "Dostępne w planie Standard",
                locked: "Zablokowane"
            },
            toggles: {
                stock_cost: "Koszt magazynu",
                wastage: "Straty",
                operational: "Tryb operacyjny",
                net_revenue: "Przychód netto (podatek)"
            },
            charts: {
                sales_title: "Wykres sprzedaży ({{currency}})",
                hourly: "Godzinowo",
                daily: "Dziennie",
                monthly: "Miesięcznie",
                distribution: "Dystrybucja",
                category_breakdown: "Podział na kategorie",
                revenue_share: "Udział w przychodach",
                no_data: "Brak danych.",
                tooltip_revenue: "Przychód: ",
                tooltip_net_revenue: "Przychód netto: ",
                tooltip_profit: "Zysk: "
            },
            transactions: {
                title: "Historia transakcji",
                count_listed: "Wyświetlono {{count}} rekordów",
                table: {
                    ticket_no: "Nr rachunku",
                    date: "Data / Czas",
                    table: "Stolik",
                    method: "Metoda",
                    amount: "Kwota",
                    status: "Status"
                },
                status: {
                    completed: "Zakończone",
                    cancelled: "Anulowane"
                },
                no_records: "Nie znaleziono transakcji w wybranym zakresie."
            },
            x_report: {
                title: "Raport stanu kasy (Raport X)",
                total_cash: "Gotówka w kasie",
                daily_tickets: "Dzienne rachunki",
                cancelled_trx: "Anulowane transakcje",
                collections: "Pobrane płatności",
                shift_reports: "Raporty zmianowe (Dzisiaj)",
                no_shift: "Brak raportów zmianowych.",
                total_sales: "SPRZEDAŻ CAŁKOWITA",
                cash: "Gotówka",
                credit_card: "Karta płatnicza",
                qr_mobile: "QR / Mobilne",
                meal_card: "Karta lunchowa"
            },
            z_report: {
                title: "Raport dobowy (Raport Z)",
                auto_toggle: "Auto Raport Z",
                auto_desc: "O 00:00",
                close_button: "ZAMKNIJ DOBĘ (RAPORT Z)",
                history_title: "Poprzednie raporty Z",
                no_reports: "Brak raportów.",
                receipt: {
                    title: "RAPORT Z",
                    report_no: "Nr raportu",
                    cashier: "Kasjer",
                    total_sales: "SPRZEDAŻ CAŁKOWITA",
                    tax_base: "Podstawa opodatkowania",
                    total_tax: "Suma podatku",
                    payment_details: "Szczegóły płatności",
                    cash: "Gotówka",
                    card: "Karta płatnicza",
                    other: "Inne",
                    end: "--- KONIEC ---"
                }
            },
            modals: {
                close_confirm: {
                    title: "Zamknąć dobę?",
                    text: "Ta akcja zarchiwizuje <strong>{{count}}</strong> otwartych transakcji i wygeneruje oficjalny Raport Z. Nie można tego cofnąć.",
                    cancel: "Anuluj",
                    confirm: "Potwierdź i zamknij"
                },
                expense: {
                    title: "Dodaj szybki wydatek",
                    date: "Data",
                    category: "Kategoria",
                    amount: "Kwota",
                    description: "Opis",
                    optional: "Opcjonalnie...",
                    set_default: "Ustaw jako domyślne dla kategorii",
                    last_trx: "Ostatnio: {{amount}} ({{date}})"
                },
                processing: {
                    title: "Generowanie raportu Z...",
                    text: "Proszę czekać, przetwarzanie końca doby..."
                }
            },
            liabilities: {
                pending: "Oczekujące płatności",
                label_today: "Dzisiejszy udział w wydatkach",
                label_week: "Tygodniowy udział w wydatkach",
                label_total: "Oczekujące płatności cykliczne"
            }
        },
        settings: {
            general: "Ustawienia ogólne",
            titles: {
                general: "Ogólne",
                expenses: "Wydatki",
                modifiers: "Modyfikatory",
                developer: "Deweloper"
            },
            descriptions: {
                general: "Ustawienia systemu, języka i firmy",
                expenses: "Konfiguracja finansowa",
                developer: "Narzędzia do symulacji i testowania"
            },
            subscription: {
                active: "AKTYWNA",
                inactive: "NIEAKTYWNA",
                expired: "WYGASŁA",
                renew: "Odnów",
                days_left: "Pozostało dni",
                next_payment: "Następna płatność",
                period_start: "Początek okresu",
                time_remaining: "Pozostały czas",
                lite_plan: "Plan Lite",
                standard_plan: "Plan Standard"
            },
            business_identity: "Dane firmy",
            financial: "Ustawienia finansowe",
            financial_desc: {
                currency_desc: "Symbol używany w całym systemie",
                pricing_desc: "Metoda obliczania podatku"
            },
            interface: {
                title: "Interfejs",
                scale: "Skala UI (Zoom)",
                scale_desc: "Dostosuj skalę dla elementów, które się nie mieszczą lub są zbyt małe/duże.",
                note: "Uwaga:",
                scale_note: "Automatyczne skalowanie jest zawsze aktywne na ekranach mniejszych niż 1366px."
            },
            operational: {
                title: "Godziny pracy i zmiany",
                start_hour: "Godzina rozpoczęcia (0-23)",
                end_hour: "Godzina zakończenia (0-23)",
                info_text: "To ustawienie określa zakres czasu wyświetlany na wykresie sprzedaży w **Panelu głównym**. Służy również jako punkt odniesienia dla raportów zmianowych.",
                updated_alert: "Godziny pracy zaktualizowane."
            },
            shortcuts: {
                staff_desc: "Zarządzaj kelnerami, baristami i adminami"
            },
            backup: {
                title: "Dane i kopia zapasowa",
                backup_now: "Kopia zapasowa",
                backup_desc: "Pobierz bazę danych (.json)",
                restore: "Przywróć",
                restore_desc: "Wybierz plik .json",
                factory_reset: "Reset do ustawień fabrycznych",
                reset_desc: "Wszystkie dane zostaną usunięte i system wróci do stanu początkowego.",
                reset_button: "Resetuj dane",
                success_restore: "Kopia zapasowa przywrócona pomyślnie."
            },
            security: {
                reset_title: "Reset do ustawień fabrycznych",
                restore_title: "Przywróć z kopii zapasowej",
                reset_text: "Tej akcji nie można cofnąć. Wszystkie dane (sprzedaż, produkty, magazyn) zostaną trwale usunięte.",
                restore_text: "Aktualne dane zostaną usunięte, a dane z wybranego pliku kopii zapasowej zostaną załadowane.",
                admin_required: "Wymagana zgoda administratora",
                enter_pin: "Proszę wprowadzić PIN",
                confirm_reset: "Usuń i resetuj",
                confirm_restore: "Rozpocznij przywracanie"
            },
            messages: {
                updated: "Ustawienia zaktualizowane.",
                error: "Wystąpił błąd."
            },
            sync: {
                title: "Synchronizacja w chmurze",
                pending: "{{count}} oczekujących pozycji",
                up_to_date: "Wszystkie dane są aktualne",
                button: "Synchronizuj teraz"
            }
        },
        financials: {
            title: "Ustawienia finansowe",
            subtitle: "Stawki podatkowe i kategorie wydatków",
            tabs: {
                taxes: "Podatki",
                expenses: "Wydatki",
                history: "Historia wydatków"
            },
            taxes: {
                title: "Stawki podatkowe",
                active_rates: "Aktywne stawki",
                rate_name: "Nazwa stawki",
                rate_percent: "Stawka %",
                description: "Opis",
                add_new: "Dodaj nową stawkę",
                category_mapping: "Mapowanie podatków dla kategorii"
            },
            expenses: {
                title: "Kategorie wydatków",
                add_new: "Dodaj kategorię",
                category_name: "Nazwa kategorii",
                description: "Opis",
                default_amount: "Domyślna kwota",
                recurring: "Cykliczne (Miesięcznie)",
                recurring_day: "Dzień miesiąca",
                distribute_daily: "Rozdzielaj dziennie w raportach"
            },
            history: {
                title: "Historia wydatków",
                filter_all: "Wszystkie kategorie",
                no_records: "Nie znaleziono rekordów.",
                table: {
                    date: "Data",
                    category: "Kategoria",
                    description: "Opis",
                    amount: "Kwota"
                }
            }
        },
        crm: {
            title: "CRM i Lojalność",
            subtitle: "Zarządzanie klientami i program lojalnościowy",
            give_points: "Przyznaj punkty",
            qr_instruction: "Zeskanuj kod QR klienta",
            generate_qr: "Generuj QR",
            qr_description: "Pokaż ten kod QR klientowi, aby dodać punkty do jego portfela.",
            customer_list: "Lista klientów",
            search_placeholder: "Szukaj klienta...",
            last_visit: "Ostatnia wizyta:",
            eligible: "Nagroda dostępna!",
            settings_title: "Ustawienia kampanii",
            target_points: "Punkty docelowe",
            reward_name: "Nazwa nagrody",
            preview: "Podgląd karty",
            target_label: "Cel",
            coming_soon: "Wkrótce"
        },
        qr: {
            title: "Menu QR",
            subtitle: "Cyfrowe menu i system zamawiania",
            simulate: "Symuluj zamówienie",
            print_selected: "Drukuj wybrane",
            lock: {
                title: "Usługi online zablokowane",
                desc: "Menu QR i funkcje zamawiania online są dostępne w planie Standard.",
                upgrade_btn: "Ulepsz plan"
            },
            print: {
                title: "Drukuj kody QR",
                scan_instruction: "Zeskanuj, aby zobaczyć menu"
            },
            preview: {
                title: "Podgląd na żywo",
                network: "Sieć:",
                password: "Hasło:",
                powered_by: "Napędzane przez KahveInn",
                disclaimer: "* To jest podgląd wyglądu stojaka QR.",
                scan_instruction: "Skanuj menu"
            },
            settings: {
                general: "Ogólne",
                active: "Aktywne",
                active_desc: "Włącz system Menu QR",
                ordering: "Zezwalaj na zamawianie",
                ordering_desc: "Klienci mogą składać zamówienia",
                sound: "Alert dźwiękowy",
                sound_desc: "Odtwórz dźwięk przy nowym zamówieniu",
                design: "Projekt",
                header_text: "Tekst nagłówka",
                theme_color: "Kolor motywu",
                wifi_ssid: "Wi-Fi SSID",
                wifi_pass: "Hasło Wi-Fi"
            },
            selection: {
                title: "Wybór stolika",
                select_all: "Zaznacz wszystko",
                previewing: "Podgląd"
            },
            modal: {
                permission_title: "Wymagane uprawnienie",
                permission_text: "Potrzebujemy uprawnień przeglądarki, aby odtwarzać powiadomienia dźwiękowe.",
                allow_btn: "Zezwól na dźwięk"
            }
        },
        staff: {
            title: "Zarządzanie personelem",
            subtitle: "Pracownicy i autoryzacja",
            tabs: {
                list: "Lista pracowników",
                roles: "Role i uprawnienia"
            },
            lite_banner: {
                title: "Plan Lite",
                desc: "Zaawansowane zarządzanie personelem jest ograniczone."
            },
            stats: {
                total: "Suma pracowników",
                on_duty: "Na zmianie"
            },
            matrix: {
                person: "Osoba"
            },
            auto_shift_report: "Auto raport zmianowy",
            modal: {
                add_title: "Dodaj pracownika",
                edit_title: "Edytuj pracownika",
                delete: "Usuń pracownika",
                name: "Imię i nazwisko",
                role: "Rola",
                pin: "Kod PIN (4 cyfry)",
                phone: "Telefon (opcjonalnie)",
                status: "Status",
                status_working: "Pracuje",
                status_off: "Po zmianie"
            },
            roles_tab: {
                title: "Role",
                subtitle: "Dostosuj uprawnienia ról",
                permissions: "Uprawnienia",
                no_permissions: "Brak przypisanych uprawnień"
            },
            contact: "Kontakt",
            status: {
                working: "Pracuje",
                offline: "Po zmianie"
            },
            permission_matrix: "Macierz uprawnień",
            no_pin_permission: "Brak uprawnień do widoku/zmiany PIN",
            unauthorized_tooltip: "Nie możesz edytować tego użytkownika",
            alerts: {
                no_add_permission: "Nie masz uprawnień do dodawania personelu.",
                no_edit_others: "Możesz edytować tylko własny profil.",
                no_edit_admin: "Tylko administratorzy mogą edytować innych administratorów.",
                no_delete_self: "Nie możesz usunąć samego siebie.",
                no_delete_permission: "Nie masz uprawnień do usuwania personelu.",
                no_delete_admin: "Tylko administratorzy mogą usuwać administratorów.",
                delete_confirm: "Czy na pewno chcesz usunąć tego pracownika?",
                no_status_admin: "Tylko administratorzy mogą zmieniać status administratora.",
                only_admin_roles: "Tylko administratorzy mogą zmieniać uprawnienia ról."
            }
        },
        permission_groups: {
            general: "Ogólne",
            sales: "Sprzedaż",
            management: "Zarządzanie"
        },
        permissions: {
            VIEW_FINANCIALS: { label: "Widok finansów", description: "Dostęp do danych o przychodach i zyskach" },
            VIEW_TABLES: { label: "Widok stolików", description: "Widok planu stolików i zamówień" },
            MANAGE_MENU: { label: "Zarządzanie menu", description: "Dodawanie i edycja produktów" },
            MANAGE_STOCK: { label: "Zarządzanie magazynem", description: "Kontrola stanów magazynowych" },
            VIEW_REPORTS: { label: "Widok raportów", description: "Dostęp do stron raportowych" },
            MANAGE_STAFF: { label: "Zarządzanie personelem", description: "Dodawanie/usuwanie pracowników" },
            MANAGE_SETTINGS: { label: "Zarządzanie ustawieniami", description: "Konfiguracja systemu" },
            VOID_ITEM: { label: "Anulowanie pozycji", description: "Operacje anulowania lub strat" },
            OFFER_COMP: { label: "Oferowanie gratisów", description: "Uprawnienie do wydawania darmowych produktów" },
            APPLY_DISCOUNT: { label: "Udzielanie rabatów", description: "Nakładanie rabatów na zamówienie" },
            CLOSE_DAY: { label: "Zamykanie doby", description: "Uprawnienie do generowania raportów Z" }
        },
        setup: {
            business_name: "Nazwa firmy",
            business_address: "Adres",
            manager_name: "Imię menedżera",
            manager_hint: "Twoje imię dla profilu menedżera",
            staff_count: "Liczba pracowników",
            staff_hint: "Szacowana liczba pracowników",
            currency: "Waluta",
            pricing_model: "Model wyceny",
            tax_inclusive: "Cena brutto (z podatkiem)",
            tax_exclusive: "Cena netto (bez podatku)",
            completing: "Kończenie konfiguracji...",
            title_1: "Witaj",
            title_2: "Zespół i zarządzanie",
            title_3: "Ustawienia finansowe",
            desc_1: "Stwórzmy tożsamość Twojej firmy.",
            desc_2: "Skonfigurujmy strukturę Twojego zespołu.",
            desc_3: "Wybierz walutę i preferencje podatkowe.",
            skip_dev: "Pomiń (Dev)",
            back: "Wstecz",
            next: "Dalej",
            finish: "Zakończ konfigurację",
            placeholders: {
                business_name: "np. KahveInn",
                city: "Miasto (np. Warszawa)",
                district: "Dzielnica (np. Śródmieście)",
                address_detail: "Ulica, nr budynku...",
                manager_name: "Twoje imię i nazwisko"
            },
            errors: {
                business_name: "Proszę wprowadzić nazwę firmy.",
                city: "Proszę wprowadzić miasto.",
                district: "Proszę wprowadzić dzielnicę.",
                address_detail: "Proszę wprowadzić pełny adres.",
                manager_name: "Proszę wprowadzić imię menedżera.",
                staff_count: "Proszę wprowadzić prawidłową liczbę pracowników."
            },
            currencies: {
                try: "Lira turecka (₺)",
                usd: "$ - Dolar amerykański ($)",
                eur: "Euro (€)",
                gbp: "Funt brytyjski (£)"
            },
            loading_text: "System jest przygotowywany, proszę czekać."
        }
    }
};